import { Box } from '@mui/material'
import { styled } from '@mui/material/styles'

export const StyledBox = styled(Box)(() => ({
  width: 'max-content',
  display: 'flex',
  alignItems: 'center',
  cursor: 'pointer'
}))
